export const TOGGLE_MAP = 'TOGGLE_MAP';

const toggleMap = () => ({
  type: TOGGLE_MAP,
});

export default toggleMap;
